import { motion } from 'framer-motion';
import styled from 'styled-components';

import { floorGameColor as color, styledTypography } from '@pkg/primitives';

import { thumbnailOverflowWrapper } from '../../../Thumbnail/Thumbnail.tokens';
import { tokens } from '../../tokens';

import { labelTransition, labelVariants, MemeSharedVariant, memeVariants, thumbnailVariants } from './Meme.motion';

interface StyledMemeProps {
    $compact?: boolean;
}

export const StyledMeme = styled(motion.div).attrs({
    variants: memeVariants,
    initial: MemeSharedVariant.Initial,
    animate: MemeSharedVariant.Show,
    exit: MemeSharedVariant.Exit,
})<StyledMemeProps>`
    --yat_meme-min-height: ${({ $compact }) => tokens.card.children.minHeight[$compact ? 'compact' : 'default']}px;
    --yat_yat_meme-thumbnail-size: ${({ $compact }) => tokens.meme.thumbnail.size[$compact ? 'compact' : 'default']}px;
    --yat_yat_meme-label-font-size: ${({ $compact }) => tokens.meme.label.fontSize[$compact ? 'compact' : 'default']}px;

    display: grid;
    align-items: center;
    grid-area: 1 / 1;
    // Required in order to prevent layout shifting.
    min-height: var(--yat_meme-min-height);
    overflow: hidden;
`;

export const Interior = styled.div`
    z-index: ${tokens.meme.zindex.interior};
    position: relative;
    display: flex;
    place-content: center;
    place-items: center;
    padding-left: ${tokens.card.children.padding}px;
    padding-right: ${tokens.card.children.padding}px;
`;

export const ThumbnailWrapper = styled(motion.div).attrs({
    variants: thumbnailVariants,
})`
    ${thumbnailOverflowWrapper(tokens.meme.thumbnail.radius)};
    flex: 0 0 auto;
    width: var(--yat_yat_meme-thumbnail-size);
    height: var(--yat_yat_meme-thumbnail-size);
    margin-left: ${tokens.meme.thumbnail.spaceBefore}px;
    margin-right: ${tokens.meme.thumbnail.spaceAfter}px;
    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.6);
`;

export const Label = styled(motion.p).attrs({
    variants: labelVariants,
    transition: labelTransition,
})`
    ${styledTypography.tuskerBase};
    ${styledTypography.lineClamp()};
    flex: 1 1 auto;
    font-size: var(--yat_yat_meme-label-font-size);
    font-weight: 700;
    font-stretch: condensed;
    text-transform: uppercase;
    text-align: center;
    line-height: 1.1;
    color: ${color.white};
    // Mitigate unused descender area.
    margin-bottom: -0.1em;
`;
